function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 2h20v2H0V2zm0 6h20v2H0V8zm0 6h20v2H0v-2z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/hamburguer.c83729fb.svg";
export { SvgComponent as ReactComponent };